import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

export default function CancellationPage() {
  return (
    <LegalPageLayout
      title="Cancellation Policy"
      subtitle="How order changes and cancellations are handled for custom-made garments."
      lastUpdated="May 16, 2026"
      activePath="/cancellation"
    >
      <div className="legal-highlight-card">
        <p>
          Maviinci garments are made specifically for each customer based on approved design,
          fabric, measurement, and styling choices. Because production is personalized, order
          changes and cancellations are possible only within limited stages of the process.
        </p>
      </div>

      <h2>1. Cancellation Before Production</h2>
      <p>
        You may request cancellation before production begins. If the order has not entered fabric
        allocation, cutting, embroidery, or stitching, Maviinci may approve cancellation and process
        the eligible refund as per payment and processing rules.
      </p>

      <h2>2. Cancellation After Production Starts</h2>
      <p>
        Once production begins, cancellation may not be possible because the garment is already
        being made to your approved specifications. Production includes fabric reservation, cutting,
        stitching, embroidery, finishing, quality check, or dispatch preparation.
      </p>

      <h2>3. Change Requests</h2>
      <p>
        Changes to design, fabric, measurements, style, delivery address, or delivery date should be
        requested as early as possible. Maviinci will try to accommodate feasible changes, but change
        requests are not guaranteed after production has started.
      </p>

      <h2>4. Refunds for Approved Cancellations</h2>
      <p>
        If a cancellation is approved, the refund will be issued to the original payment method.
        A 2% payment processing fee may be deducted from the refundable amount. Refunds are
        generally processed within 5-7 business days after approval.
      </p>

      <h2>5. Non-Cancellable Cases</h2>
      <ul>
        <li>The order has already entered cutting, stitching, embroidery, finishing, or dispatch.</li>
        <li>Fabric has been specially procured or reserved for your order.</li>
        <li>The cancellation request is based on change of mind or occasion cancellation after production begins.</li>
        <li>The order is part of a bulk, campus, corporate, or wedding group order with confirmed production planning.</li>
      </ul>

      <h2>6. How to Request Cancellation</h2>
      <p>Please contact Maviinci Customer Support with:</p>
      <ul>
        <li>Order number</li>
        <li>Registered phone number or email</li>
        <li>Reason for cancellation or change request</li>
      </ul>

      <div className="legal-info-card">
        <div className="legal-info-row">
          <span className="legal-info-label">Email</span>
          <span className="legal-info-value">connect@bluepearlindustries.com</span>
        </div>
        <div className="legal-info-row">
          <span className="legal-info-label">Phone/WhatsApp</span>
          <span className="legal-info-value">+91-8871081395</span>
        </div>
      </div>

      <div className="legal-other-policies">
        <h3>Related Policies</h3>
        <div className="legal-other-policies-grid">
          <Link to="/terms" className="legal-policy-chip">Terms & Conditions</Link>
          <Link to="/privacy" className="legal-policy-chip">Privacy Policy</Link>
          <Link to="/shipping" className="legal-policy-chip">Shipping & Delivery</Link>
          <Link to="/returns" className="legal-policy-chip">Return & Refund Policy</Link>
        </div>
      </div>
    </LegalPageLayout>
  );
}
